import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';


import {Icon, iconConstants} from '../../Icon';
import {I18nMessage} from '../../../contexts/I18n';

import styles from './IconLink.scss';


function IconLink({icon, iconType, label, labelI18n, onClick, url}) {

    const navigate = useNavigate();

    return (
        <span
            className={styles.iconLink}
            onClick={event => {
                event.preventDefault();

                if (onClick) {

                    return onClick();
                }

                navigate(url);
            }}
        >
            {icon || <Icon icon={iconType}/>}
            {(label || labelI18n) && (
                <a>
                    {label || <I18nMessage id={labelI18n}/>}
                </a>
            )}
        </span>
    );
}


IconLink.propTypes = {
    icon: PropTypes.element,
    iconType: PropTypes.oneOf(iconConstants.ICONS),
    label: PropTypes.string,
    labelI18n: PropTypes.string,
    onClick: PropTypes.func,
    url: PropTypes.string
};

IconLink.defaultProps = {};


export default IconLink;
